<template>
  <div class="bg-[#F2F6FA] h-full">
    <div class="flex flex-col items-center justify-center w-full pb-20 py-4">
      <section class="flex flex-col items-center w-full justify-center">
        <div
          class="flex items-center justify-between md:mt-5 mb-2 md:mb-0 mt-2 px-2 md:px-0 w-full"
        >
          <div class="flex justify-between items-center w-full">
            <div>
              <div class="items-center gap-2 px-4 -ml-2 d-flex">
                <img
                  src="@/assets/img/sidebar/icons8-rank-64.png"
                  class="cursor-pointer w-6 md:w-[28px]"
                  alt="analysis"
                />
                <div class="flex items-center gap-1">
                  <p class="text-base md:text-[22px] font-bold">
                    Local Rank Insights
                    <!-- <sup class="text-sm text-gray-500 pl-2">Beta</sup> -->
                  </p>
                </div>
              </div>
            </div>
            <div
              class="items-center d-flex pr-4"
              v-if="activeTab == 1 && selectedDate"
            >
              <!-- display date only if present and not invalid date -->
              <!-- <span
                class="text-sm text-gray-500 font-semibold"
                v-if="currentDataDate"
                >Generated on {{ currentDataDate }}</span
              > -->
              <span
                class="text-sm text-gray-500 font-semibold"
                v-if="selectedDate"
                >Generated on {{ selectedDate }}</span
              >
            </div>
          </div>
        </div>
        <div
          class="flex items-center justify-start mb-3 ml-[48px] md:mb-0 px-2 md:px-0 w-full"
          v-if="activeTab == 1"
        >
          <div class="items-center gap-2 px-4 d-flex">
            <div class="flex items-center gap-1">
              <p class="text-lg md:text-[18px] text-gray-600">
                See all insights on your rank amongst local competitors across
                top keywords
              </p>
            </div>
          </div>
        </div>
        <!-- <div
          class="flex items-center justify-start mb-1 md:mb-0 px-1 mt-3 w-full"
        >
          <div class="text-base text-orange-500 font-semibold">
            Note: This is an experimental feature and we're actively working on
            improvements.
          </div>
        </div> -->
        <div
          v-if="isLoading"
          class="min-h-screen w-full flex items-center justify-center"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="34"
          ></v-progress-circular>
          <span class="ml-4 text-gray-600">Loading local rank insights...</span>
        </div>
        <div
          v-else-if="dataReady"
          class="min-h-screen w-full overflow-x-hidden rounded-2xl mt-2"
        >
          <v-tabs v-model="activeTab">
            <v-tab value="0">Dashboard</v-tab>
            <v-tab value="1">Rank Explorer</v-tab>
            <v-tab value="2">Rank Trends</v-tab>
            <v-tab value="3">Keywords Settings</v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab" class="rounded-b-2xl">
            <v-tab-item :value="0" class="mt-5">
              <GMBCompetitorDashboard
                :stores="stores"
                :locationRanks="locationRanks"
                :locationSearch="locationSearch"
                :selectedWIDs.sync="selectedWIDs"
                :lastDateIndex="lastDateIndex"
                :locationRanksPerformance="locationRanksPerformance"
                @selectedDate="handleSelectedDate"
                @update:selectedWIDs="selectedWIDs = $event"
              />
            </v-tab-item>
            <v-tab-item :value="1" class="mt-5">
              <GMBCompetitorRankTracker
                :stores="stores"
                :locationSearch="locationSearch"
                :selectedWIDs="selectedWIDs"
                :initialLocationId="initialLocationId"
                :initialKeyword="initialKeyword"
                :selectedDate="selectedDate"
                @update:selectedWID="handleSelectedWIDChange"
                @rank-data-date-updated="handleRankDataDateUpdate"
              />
            </v-tab-item>
            <v-tab-item :value="2" class="mt-5">

              <div class="pa-4">
                <!-- <v-btn-toggle
                  v-model="rankTrendsView"
                  mandatory
                  dense
                  class="mb-4"
                >
                  <v-btn value="table">Table View</v-btn>
                  <v-btn value="graph" class="ml-2">Graph View</v-btn>
                </v-btn-toggle> -->

                <div v-if="rankTrendsView === 'table'">
                  <WeeklyHeatmaps
                    v-if="selectedWIDs.length > 0"
                    :stores="stores"
                    :selectedWIDs="selectedWIDs"
                    :currentUID="currentUID"
                  />
                  <div
                    v-if="selectedWIDs.length === 0"
                    class="text-center text-gray-500 mt-5"
                  >
                    Please select at least one location to see the table.
                  </div>
                </div>
                <div v-if="rankTrendsView === 'graph'">
                  <!-- Placeholder for Graph View -->
                  <p class="text-gray-600">
                    Rank Trends Graph View will be displayed here.
                  </p>
                  <!-- You can replace this with your actual graph component or implementation -->
                  <div
                    v-if="selectedWIDs.length === 0"
                    class="text-center text-gray-500 mt-5"
                  >
                    Please select at least one location to see rank trends.
                  </div>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item :value="3" class="mt-5">
              <GmbKeywordsSetting />
            </v-tab-item>
          </v-tabs-items>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { httpsCallable } from "firebase/functions";
import GMBCompetitorDashboard from "./gmb_competitors_components/GMBCompetitorDashboard.vue";
import GMBCompetitorRankTracker from "./gmb_competitors_components/GMBCompetitorRankTracker.vue";
import WeeklyHeatmaps from "./gmb_competitors_components/WeeklyHeatmaps.vue";
import GmbKeywordsSetting from "./gmb_competitors_components/GmbKeywordsSetting.vue";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";
import { functions, colUsers, auth, db } from "@/utils/firebase.utils"; // Ensure this import matches your project structure
import moment from "moment";

export default {
  components: {
    GMBCompetitorDashboard,
    GMBCompetitorRankTracker,
    WeeklyHeatmaps,
    GmbKeywordsSetting,
  },
  data() {
    return {
      activeTab: 0,
      stores: [],
      locationSearch: "",
      selectedWIDs: [],
      locationRanks: [],
      locationRanksPerformance: null,
      isLoading: true,
      dataReady: false,
      currentSelectedWID: "",
      rankReportGenerationDate: null,
      currentDataDate: null, // New property for the actual data date
      initialLocationId: null,
      initialKeyword: null,
      tabs: {
        dashboard: 0,
        rank_explorer: 1,
        rank_trends: 2,
      },
      rankTrendsView: "table", // Default view for Rank Trends updated to table
      lastDateIndex: 0,
      selectedDate: null,
      isFetchingRanks: false,
      ranksFetchTimeout: null,
      globalStoresReady: false,
    };
  },
  async created() {
    this.checkUrlParams();
  },
  watch: {
    // update locations on change in query
    "$route.query.location": {
      handler(newVal) {
        if (newVal) {
          this.selectedWIDs = newVal.split(",");
          // Update checked state for all stores
          this.stores.forEach((store) => {
            store.checked = this.selectedWIDs.includes(store.wid);
          });
        } else {
          // If no location in URL, select all locations
          this.selectedWIDs = this.stores.map((store) => store.wid);
          this.stores.forEach((store) => {
            store.checked = true;
          });
        }
      },
    },
    // Watch for changes in selectedWIDs
    selectedWIDs: {
      handler(newVal) {
        // Update URL when selection changes
        if (newVal && newVal.length > 0) {
          // Only update URL if selection is different from all locations
          if (newVal.length < this.stores.length) {
            this.modifyUrlParams("location", newVal.join(","));
          } else {
            // If all locations are selected, remove the location parameter
            const { location, ...otherQueries } = this.$route.query;
            if (!location) {
              this.$router.replace({ query: otherQueries });
            }
          }
        } else {
          // If no locations selected, remove location parameter
          const { location, ...otherQueries } = this.$route.query;
          // if there are no locations in the query, then remove the location parameter
          if (!location) {
            this.$router.replace({ query: otherQueries });
          }
        }
        // Debounced fetch to prevent multiple rapid requests
        this.debouncedFetchRanks();
      },
    },
    globalStores: {
      immediate: true,
      async handler(newStores) {
        if (newStores && newStores.length > 0) {
          await this.fetchStores();
          // After stores are fetched, trigger debounced fetch
          this.debouncedFetchRanks();
          this.globalStoresReady = true;
        }
      },
    },
    $route: {
      immediate: true,
      handler() {
        this.checkUrlParams();
      },
    },
    activeTab: {
      handler(newVal) {
        // Convert numeric tab index to string name for URL if it's a number else keep it as is
        if (typeof newVal === "number") {
          const tabName = Object.keys(this.tabs).find(
            (key) => this.tabs[key] === newVal
          );
          if (tabName) {
            // Dashboard tab (0) - remove keyword param when switching to dashboard
            if (newVal === 0 && this.$route.query.keyword) {
              const { keyword, ...otherQueries } = this.$route.query;
              this.$router.replace({
                query: { ...otherQueries, tab: tabName },
              });
            } else {
              this.modifyUrlParams("tab", tabName);
            }
          }
        } else {
          this.modifyUrlParams("tab", newVal);
        }
        if (newVal === 1 && !this.$route.query.date) {
          if (this.locationRanks && this.locationRanks.length > 0) {
            const reversedLocationRanks = this.locationRanks.reverse();
            const latestDateData = reversedLocationRanks[reversedLocationRanks.length - 1];
            if (latestDateData && latestDateData.date) {
              this.selectedDate = moment(latestDateData.date).format(
                "DD MMM YYYY"
              );
            }
          }
        }
      },
    },
  },
  methods: {
    handleSelectedDate(date) {
      this.selectedDate = moment(date).format("DD MMM YYYY");
    },
    handleRankDataDateUpdate(originalDate) {
      // format date.value to dd-mm-yyyy
      let date = originalDate?.value
        ? new Date(originalDate.value)
        : originalDate
        ? new Date(originalDate)
        : null;
      if (!date) {
        this.currentDataDate = null;
        return;
      }
      date = moment(date).format("DD MMM YYYY");
      this.currentDataDate = date;
    },
    checkUrlParams() {
      // Get location and keyword from URL if present
      const { location, keyword, tab, date } = this.$route.query;
      if (tab) {
        if (typeof tab === "string") {
          this.activeTab = this.tabs[tab];
        } else {
          this.activeTab = tab;
        }
      }
      if (date) {
        this.selectedDate = moment(date).format("DD MMM YYYY");
      }
      if (location || keyword) {
        // If either parameter is present, set active tab to Rank Explorer (index 1)
        // commented this because on location change it was going to rank explorer tab everytime
        // this.activeTab = 1;
      }

      // Store for passing to GMBCompetitorRankTracker
      this.initialLocationId = location || null;
      this.initialKeyword = keyword || null;
    },
    modifyUrlParams(param, value) {
      // Check if the current value in the URL is already the same
      if (this.$route.query[param] === value) {
        return; // Skip redundant navigation
      }
      // Only update the URL if the value is different
      this.$router.replace({ query: { ...this.$route.query, [param]: value } });
    },
    handleSelectedWIDChange(wid) {
      this.currentSelectedWID = wid;
      this.fetchRankReportGenerationDate();
    },
    async fetchRankReportGenerationDate() {
      const uid = this.currentUID;
      const storeRef = doc(
        db,
        "users",
        uid,
        "fly_workspaces",
        this.currentSelectedWID
      );
      const docSnap = await getDoc(storeRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        const rankTrackerLastRun =
          data?.rank_tracker_last_run && data.rank_tracker_last_run != undefined
            ? new Date(
                data.rank_tracker_last_run.seconds
                  ? data.rank_tracker_last_run.seconds * 1000
                  : data.rank_tracker_last_run
              )
            : null;
        this.rankReportGenerationDate = rankTrackerLastRun
          ? rankTrackerLastRun
          : null;
        // console.log(rankTrackerLastRun, this.rankReportGenerationDate, "Rank report generation date");
      } else {
        console.error("No such document!");
      }
    },
    async fetchStores() {
      // Use the global stores from Vuex
      this.stores = [];
      this.selectedWIDs = [];
      if (!this.globalStores || this.globalStores.length === 0) {
        console.warn("Global stores not available yet, waiting...");
        await this.waitForGlobalStores();
      }
      const locationParam = this.$route.query.location;
      const locationIds = locationParam
        ? Array.isArray(locationParam)
          ? locationParam
          : [locationParam]
        : [];
      // Convert to array if it's a comma-separated string
      const locationIdsArray =
        locationIds.length === 1 && locationIds[0].includes(",")
          ? locationIds[0].split(",").map((id) => id.trim())
          : locationIds;
      // Process the existing store data
      this.globalStores.forEach((storeData) => {
        // Add computed properties that aren't stored in Firestore
        const shouldBeChecked =
          locationIdsArray.length === 0 || // If no locations specified, check all
          locationIdsArray.includes(storeData.id);
        const storeObj = {
          ...storeData,
          isRankTracker: true,
          display_name: `${
            storeData.sub_locality ? storeData.sub_locality + "- " : ""
          } ${storeData.name || ""}`,
          id: storeData.id,
          wid: storeData.id,
          type: "store",
          checked: shouldBeChecked,
          isReview: true,
          isSelectable: true, // Add isSelectable property
        };

        this.stores.push(storeObj);

        if (shouldBeChecked) {
          this.selectedWIDs.push(storeData.id);
        }
      });

      // If no locations were specified in URL, select all by default
      if (locationIdsArray.length === 0) {
        this.selectedWIDs = this.stores.map((store) => store.id);
        this.stores.forEach((store) => {
          store.checked = true;
        });
      }

      return true;
    },
    getLastSixMonths() {
      const months = [];
      const currentDate = new Date();
      for (let i = 0; i < 6; i++) {
        const date = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() - i,
          1
        );
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        months.push(`${month}-${year}`);
      }
      return months;
    },
    async fetchRanksForLocation(locationId, months) {
      const ranks = {};
      const promises = months.map((month) => {
        const docRef = doc(
          db,
          `fly_rank_tracker_keywords_ranks/${locationId}/month-wise-ranks`,
          month
        );
        return getDoc(docRef)
          .then((docSnap) => {
            if (docSnap.exists()) {
              ranks[month] = docSnap.data();
            }
          })
          .catch((error) => {
            console.warn(
              `Failed to fetch rank for ${locationId} - ${month}:`,
              error
            );
          });
      });
      await Promise.all(promises);
      return { locationId, ranks };
    },
    // Debounced method to prevent multiple requests
    debouncedFetchRanks() {
    // Clear any existing timeout
    if (this.ranksFetchTimeout) {
      clearTimeout(this.ranksFetchTimeout);
    }

    // Set a new timeout to fetch ranks after a short delay
    this.ranksFetchTimeout = setTimeout(() => {
      // Only fetch if conditions are met and not already fetching
      if (
        this.globalStoresReady &&
        this.selectedWIDs &&
        this.selectedWIDs.length > 0 &&
        this.stores.length > 0 &&
        !this.isFetchingRanks
      ) {
        this.fetchLocationRanksWithGuard();
      }
    }, 300); // 300ms delay to debounce rapid changes
  },

    // Guarded version of fetchLocationRanks to prevent multiple simultaneous requests
    async fetchLocationRanksWithGuard() {
      if (this.isFetchingRanks) {
        console.log("Already fetching ranks, skipping request");
        return;
      }

      this.isFetchingRanks = true;
      try {
        await this.fetchLocationRanks();
        this.dataReady = true;
      } catch (error) {
        console.error("Error fetching location ranks:", error);
      } finally {
        this.isFetchingRanks = false;
        this.isLoading = false;
      }
    },

    resetData() {
      this.locationRanks = [];
      this.locationRanksPerformance = null;
      this.lastDateIndex = 0;
      this.$store.commit("SET_AVAILABLE_RANK_TRACKER_DATES", []);
    },

    async fetchLocationRanks() {
      try {
        this.resetData();
        // const promises = this.stores.map((store) => {
        const payload = {
          uid: this.currentUID,
          wids: this.selectedWIDs,
          date: this.selectedDate,
          source: "new",
        };
        // dont fetch if no wid is selected
        if (this.selectedWIDs.length === 0) {
          this.resetData();
          return;
        }
        const idToken = await auth.currentUser.getIdToken();
        // check how much time it took to get the response
        const response = await fetch(
          `${process.env.VUE_APP_ENGINE_ENDPOINT}/functions/fetchCompetitorAnalysisDashboardReport`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${idToken}`,
            },
            body: JSON.stringify({ data: payload }),
          }
        );
        if (response.ok) {
          const result = await response.json();
          this.locationRanks = result.rankData;
          this.locationRanksPerformance = result.performance;
          let dates = this.locationRanks
            .map((rankData, index) => ({
              date: rankData.date || `Date ${index + 1}`,
              index,
            }))
            .reverse();
          this.lastDateIndex = dates.length - 1;
          this.$store.commit("SET_AVAILABLE_RANK_TRACKER_DATES", dates);
        }
        console.log("Location ranks fetched:", this.locationRanks);
      } catch (error) {
        console.error("Error fetching location ranks:", error);
      }
      return true;
    },

    async loadAllData() {
      try {
        this.isLoading = true;
        await this.waitForGlobalStores();
        // Load stores first
        const storesLoaded = await this.fetchStores();
        if (!storesLoaded) {
          console.error("Failed to load stores");
          return;
        }

        // Use the guarded method to fetch ranks
        await this.fetchLocationRanksWithGuard();

        // After data is ready, check if we need to navigate to a specific location/keyword
        if (this.initialLocationId && this.activeTab === 1) {
          // Make sure we're on the right tab for the location/keyword parameters
          this.$nextTick(() => {
            // Next tick ensures the tab content is rendered
            this.activeTab = 1;
          });
        }
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.isLoading = false;
      }
    },
    // Wait for global stores to be ready
    async waitForGlobalStores() {
      return new Promise((resolve) => {
        if (this.globalStores && this.globalStores.length > 0) {
          this.globalStoresReady = true;
          resolve();
        } else {
          // Watch for globalStores to become available
          const unwatch = this.$watch('globalStores', (newStores) => {
            if (newStores && newStores.length > 0) {
              this.globalStoresReady = true;
              unwatch(); // Stop watching
              resolve();
            }
          }, { immediate: true });
        }
      });
    },
  },
  async mounted() {
    if (this.globalStores && this.globalStores.length > 0) {
      await this.loadAllData();
    } else {
      console.log("Global stores not ready on mount, waiting for watcher...");
    }
  },
  // Clean up timeout when component is destroyed
  beforeDestroy() {
    if (this.ranksFetchTimeout) {
      clearTimeout(this.ranksFetchTimeout);
    }
  },
};
</script>
